<template>
  <div style="margin: 10px">
    <v-form>
      <v-card>
        <div class="headline dialog-header">
          <v-toolbar color="primary" dark>
            <v-toolbar-title
            >{{ $t(formName) }}
            </v-toolbar-title>
          </v-toolbar>
        </div>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs6 sm6 md6>
              <div style="padding: 40px">
                <p class="font-weight-bold">
                  Level 1
                </p>
                <p class="font-weight-normal">
                  Tổng số user: {{ totalKid1 }}
                </p>
                <p class="font-weight-normal">
                  Học sinh học nhanh: {{ totalKidFast1 }}
                </p>
                <p class="font-weight-normal">
                  Học sinh học chậm: {{ totalKidSlow1 }}
                </p>
                <p class="font-weight-normal">
                  Học sinh học đúng tiến độ: {{ totalKidEqual1  }}
                </p>
              </div>
              <div style="padding: 40px">
                <p class="font-weight-bold">
                  Level 2
                </p>
                <p class="font-weight-normal">
                  Tổng số user: {{ totalKid2 }}
                </p>
                <p class="font-weight-normal">
                  Học sinh học nhanh: {{ totalKidFast2 }}
                </p>
                <p class="font-weight-normal">
                  Học sinh học chậm: {{ totalKidSlow2 }}
                </p>
                <p class="font-weight-normal">
                  Học sinh học đúng tiến độ: {{ totalKidEqual2 }}
                </p>
              </div>
              <div style="padding: 40px">
                <p class="font-weight-bold">
                  Level 3
                </p>
                <p class="font-weight-normal">
                  Tổng số user: {{ totalKid3 }}
                </p>
                <p class="font-weight-normal">
                  Học sinh học nhanh: {{ totalKidFast3 }}
                </p>
                <p class="font-weight-normal">
                  Học sinh học chậm: {{ totalKidSlow3 }}
                </p>
                <p class="font-weight-normal">
                  Học sinh học đúng tiến độ: {{ totalKidEqual3 }}
                </p>
              </div>
            </v-flex>
            <v-flex xs6 sm6 md6>
              <div style="padding: 40px">
                <p class="font-weight-bold">
                  Level 4
                </p>
                <p class="font-weight-normal">
                  Tổng số user: {{ totalKid4 }}
                </p>
                <p class="font-weight-normal">
                  Học sinh học nhanh: {{ totalKidFast4 }}
                </p>
                <p class="font-weight-normal">
                  Học sinh học chậm: {{ totalKidSlow4 }}
                </p>
                <p class="font-weight-normal">
                  Học sinh học đúng tiến độ: {{ totalKidEqual4 }}
                </p>
              </div>
              <div style="padding: 40px">
                <p class="font-weight-bold">
                  Level 5
                </p>
                <p class="font-weight-normal">
                  Tổng số user: {{ totalKid5 }}
                </p>
                <p class="font-weight-normal">
                  Học sinh học nhanh: {{ totalKidFast5 }}
                </p>
                <p class="font-weight-normal">
                  Học sinh học chậm: {{ totalKidSlow5 }}
                </p>
                <p class="font-weight-normal">
                  Học sinh học đúng tiến độ: {{ totalKidEqual5 }}
                </p>
              </div>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>

            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import IDatepicker from "../../../components/form/DatePicker";
import { message } from "../../../shared/message";
import CTextboxFloat from "@/components/form/TextboxFloat";

export default {
  name: "ImportRequestView",
  components: {CTextboxFloat, IDatepicker },
  data: () => {
    return {
      formName: "Tổng quan",
      loading: false,
      warehouseCode: "",
      roleGroup: 0,
      userId: '',
      isEdit: false,
      totalKidSum:null,
      totalKidSlowSum:null,
      totalKidEqualSum:null,
      totalKidFastSum:null,
      totalKid1:null,
      totalKidSlow1:null,
      totalKidEqual1:null,
      totalKidFast1:null,
      totalKid2:null,
      totalKidSlow2:null,
      totalKidEqual2:null,
      totalKidFast2:null,
      totalKid3:null,
      totalKidSlow3:null,
      totalKidEqual3:null,
      totalKidFast3:null,
      totalKid4:null,
      totalKidSlow4:null,
      totalKidEqual4:null,
      totalKidFast4:null,
      totalKid5:null,
      totalKidSlow5:null,
      totalKidEqual5:null,
      totalKidFast5:null,
      deleteDialog: false,
      requestOrder: null,
      importRequest: {
        status: 1,
        dateArrived: '',
      },
      historyDlg: false,
      lstHistory: [],
    };
  },

  created() {

    axios.post(
        process.env.VUE_APP_API_URL + "/kidClass/listAllClass/"+1, {levelId: 1, status: 1}
    )
        .then(
            (data) => {
              this.totalKid1 = data.totalKidSum;
              this.totalKidSlow1 = data.totalKidSlowSum;
              this.totalKidEqual1 = data.totalKidEqualSum;
              this.totalKidFast1 = data.totalKidFastSum;
            }
        );

    axios.post(
        process.env.VUE_APP_API_URL + "/kidClass/listAllClass/"+2, {levelId: 2, status: 1}
    )
        .then(
            (data) => {
              this.totalKid2 = data.totalKidSum;
              this.totalKidSlow2 = data.totalKidSlowSum;
              this.totalKidEqual2 = data.totalKidEqualSum;
              this.totalKidFast2 = data.totalKidFastSum;
            }
        );

    axios.post(
        process.env.VUE_APP_API_URL + "/kidClass/listAllClass/"+3, {levelId: 3, status: 1}
    )
        .then(
            (data) => {
              this.totalKid3 = data.totalKidSum;
              this.totalKidSlow3 = data.totalKidSlowSum;
              this.totalKidEqual3 = data.totalKidEqualSum;
              this.totalKidFast3 = data.totalKidFastSum;
            }
        );

    axios.post(
        process.env.VUE_APP_API_URL + "/kidClass/listAllClass/"+4, {levelId: 4, status: 1}
    )
        .then(
            (data) => {
              this.totalKid4 = data.totalKidSum;
              this.totalKidSlow4 = data.totalKidSlowSum;
              this.totalKidEqual4 = data.totalKidEqualSum;
              this.totalKidFast4 = data.totalKidFastSum;
            }
        );
    axios.post(
        process.env.VUE_APP_API_URL + "/kidClass/listAllClass/"+5, {levelId: 5, status: 1}
    )
        .then(
            (data) => {
              this.totalKid5 = data.totalKidSum;
              this.totalKidSlow5 = data.totalKidSlowSum;
              this.totalKidEqual5 = data.totalKidEqualSum;
              this.totalKidFast5 = data.totalKidFastSum;
            }
        );
  },

  computed: {
  },

  methods: {
    onCancel() {
      //this.$router.push({ path: '/importRequest' });
      this.$router.push({ path: '/account/accountList', query: this.$route.query });
    },

    onLiveClass() {
      this.$router.push({ path: '/liveClassPointInfo/view/'+this.accountId, query: this.$route.query });
    },

    onCategoytis() {
    },

    onMission() {
    },

    onFeedback() {
    },

    onHistory() {
    },
  },

  destroyed() {},
};
</script>
